/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface NotificaPushUtenteForm { 
    /**
     * Identificativo dell\'utente destinatario. Non puo\' essere nullo o vuoto.
     */
    user_id: string;
    /**
     * Titolo della notifica, mostrato in grassetto sul dispositivo.
     */
    titolo: string;
    /**
     * Corpo del messaggio.
     */
    messaggio: string;
}

